export const MAX_ANSWER_COUNT = 10;
